export default __webpack_public_path__ + "static/magda-eda6b393caae905361b29a28530e58a8.png";